/**
 * Filtro de janela de audiência — compartilhado entre Esteira e Broadcast.
 * O filtro é aplicado no ms-meta-flow na hora de selecionar os leads.
 *
 * - 24h: última interação do lead (janela padrão da Meta).
 * - 7 dias (geral): última interação do lead.
 * - 7 dias do anúncio: último clique em anúncio Click-to-Messenger. Nesse
 *   período a Meta aceita mensagem promocional SEM tag (medido em 2026-10).
 */
export type AudienceWindow =
    | 'all'
    | 'in_window'
    | 'out_window'
    | 'in_7d'
    | 'out_7d'
    | 'in_ad_7d'
    | 'out_ad_7d';

export const AUDIENCE_WINDOW_OPTIONS: { v: AudienceWindow; label: string; hint: string }[] = [
    { v: 'all', label: 'Todos os leads ativos', hint: 'padrão' },
    { v: 'in_window', label: 'Só dentro da janela 24h', hint: 'interagiram nas últimas 24h' },
    { v: 'out_window', label: 'Só fora da janela 24h', hint: 'exige template aprovado' },
    { v: 'in_7d', label: 'Só dentro de 7 dias', hint: 'interagiram nos últimos 7 dias' },
    { v: 'out_7d', label: 'Só fora de 7 dias', hint: 'sem interação há mais de 7 dias' },
    { v: 'in_ad_7d', label: 'Só dentro de 7 dias do anúncio', hint: 'clicaram num anúncio nos últimos 7 dias · aceita promo sem tag' },
    { v: 'out_ad_7d', label: 'Só fora de 7 dias do anúncio', hint: 'sem clique em anúncio nos últimos 7 dias' },
];

/** Janelas em que (parte d)os leads está fora de 24h e fora do anúncio:
 *  envio raw/promo leva #10 da Meta — precisa de template aprovado. */
export const AUDIENCE_NEEDS_TEMPLATE: AudienceWindow[] = ['out_window', 'in_7d', 'out_7d', 'out_ad_7d'];
